import React from "react";
//#region types
import { CommonEnums } from "models/enums";
import { DateHelper } from "utils/helpers";
//#endregion
//#region components
import { DateRange } from "models/formTypes/util";
import useAccountingDateRanges from "./useDateRanges";
//#endregion

function useMonthlyReportDefaults() {
  const getMonthPickerQuickSelections = useAccountingDateRanges();

  const getDefaultMonthRange = React.useCallback(() => {
    const selections = getMonthPickerQuickSelections();
    const quickSelections = selections.primaryColumnQuickSelections;

    let defaultSelection = quickSelections.find((q) => q.key === CommonEnums.AccountingDateTypes.FinancialYear);

    if (!defaultSelection) {
      defaultSelection = quickSelections.find((q) => q.key === CommonEnums.AccountingDateTypes.LastYear);
    }

    const range = defaultSelection?.range as DateRange;

    return {
      yearMonthRange: {
        startMonth: range.start ? DateHelper.getYearMonthByDate(range.start) : undefined,
        endMonth: range.end ? DateHelper.getYearMonthByDate(range.end) : undefined,
      },
      monthRange: range,
    };
  }, [getMonthPickerQuickSelections]);

  return { getDefaultMonthRange };
}

export default useMonthlyReportDefaults;
